import TaxForm from "@/components/TaxBureauStep/TaxForm";
import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import RenderQRcode from "./RenderQRcode";
import styles from "./index.less";
import { Button, message, Spin } from "antd";
import { getEnterpriseQrCode, getEnterpriseQrCodeStatus, getPersonalQrCode, getPersonalQrCodeStatus } from "@/api/taxAuth";
import { useRequest } from "ahooks";
import { requestMiddleware } from "@/utils/taxUtil";

const setpFormConfig = ["taxDeclareProvince", "companyName"];

const getQRCode = async (type, params) => {
  if (type === "ENTERPRISE") {
    return requestMiddleware(getEnterpriseQrCode(params));
  }
  return requestMiddleware(getPersonalQrCode(params));
};

const getStatus = async (type, params) => {
  if (type === "ENTERPRISE") {
    return requestMiddleware(getEnterpriseQrCodeStatus(params), '000000');
  }
  return requestMiddleware(getPersonalQrCodeStatus(params), '000000');
}

const APP_LIST = [
  { label: "电子税务局APP", value: "ENTERPRISE" },
  // { label: "个人所得税APP", value: "PERSONAL" },
];

const QRCodeTab = ({ taxHelperStore, onFinishAuth }) => {
  /** 表单区域引用 */
  const [taxFormRef] = useState(React.createRef());
  const [type, setType] = useState(APP_LIST[0].value);
  // 过期状态
  const [expired, setExpired] = useState(false)

  const { province, serialNo, nsrsbh } = taxHelperStore.authQueryParams;

  const { run, cancel } = useRequest(() => getStatus(type, {serialNo}), {
    manual: true,
    pollingInterval: 3000,
    onSuccess: (res) => {
      const { code } = res;
      // 已认证
      if (code === '10000') {
        cancel()
        onFinishAuth?.()
        return;
      }
      // 二维码失效
      if (code === '1001002') {
        setExpired(true)
        return;
      }
      // 待扫码
      if (code === '1001005') {
        // nothing to do
        return
      }
      if (res.message) {
        // 其他错误
        message.error(res.message)
      }
    },
    onError: () => {
      cancel()
    }
  });

  const { data, loading, refresh } = useRequest(
    () =>
      getQRCode(type, {
        serialNo,
        creditCode: nsrsbh,
        area: province,
      }),
    {
      refreshDeps: [type, province],
      onSuccess: () => {
        run();
      },
      onError: () => {
        cancel();
      }
    }
  );
  

  /** 表单实例 */
  const formInstances = () => {
    return taxFormRef.current.formRef.current;
  };

  /**
   * 自动填入授权省份，企业名称
   */
  useEffect(() => {
    const { qymc, province } = taxHelperStore.authQueryParams;
    formInstances().setFieldsValue({
      companyName: qymc,
      taxDeclareProvince: province,
    });
  }, [taxHelperStore.authQueryParams]);

  return (
    <div>
      <TaxForm
        formStep="first"
        ref={taxFormRef}
        setpFormConfig={setpFormConfig}
        formInstances={formInstances}
        NEW_AUTH
      />
      <div className={styles.qrcodeContent}>
        <p className={styles.title}>
          打开<span>{APP_LIST.find((item) => item.value === type)?.label}</span>扫一扫
        </p>
        <Spin spinning={loading} tip="二维码加载中...">
          <div className={styles.qrcodeBox}>
            {
              !loading && (
                <RenderQRcode type={type} data={data}/>
              )
            }
            {/* 蒙城 */}
            {
              expired && (
                <div className={styles.mask} onClick={() => {
                  refresh()
                  setExpired(false)
                }}>
                  <div>
                  二维码已失效，点击刷新
                  </div>
                </div>
              )
            }
          </div>
        </Spin>
        <p className={styles.tip}>截图后，2分钟内用对应APP完成扫码</p>
        <div className={styles.appList}>
          {APP_LIST.map((item) => {
            return (
              <Button
                shape="round"
                key={item.value}
                type={item.value === type ? "primary" : "default"}
                onClick={() => {
                  setType(item.value)
                  cancel()
                }}
              >
                {item.label}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default inject(
  "taxHelperStore",
  "taxAuthStore"
  // 'provinceStore'
)(observer(QRCodeTab));

// export default QRCodeTab;
